// Adapted from: https://github.com/bmcmahen/react-page-controller which is distributed under MIT license
import * as React from 'react'

import {disablePageScroll, enablePageScroll} from 'scroll-lock'

function useScrollLock(enabled: boolean = true, ref?: React.RefObject<HTMLElement>) {
  const disabledRef = React.useRef(false)

  // scroll-lock uses an internal queue. we need to ensure that we only enable
  // scrolling here if we have already disabled scrolling.
  React.useEffect(() => {
    if (enabled && !disabledRef.current) {
      disablePageScroll(ref && ref.current !== null ? ref.current : undefined)
      disabledRef.current = true
    }

    const refPropCopy = ref?.current

    return () => {
      if (disabledRef.current) {
        enablePageScroll(refPropCopy ?? undefined)
        disabledRef.current = false
      }
    }
  }, [enabled, ref, disabledRef])
}

export default useScrollLock
